export const PngIcon = ({ src, className = "h-[7vh]" }) => {
  return <img 
    src={src} 
    alt="" 
    className={className} />
}